import { Component, OnInit } from '@angular/core';
import * as _moment from 'moment';
import { OwlOptions } from 'ngx-owl-carousel-o';

type CarouselItemsType = {
  key: number;
  redirectUrl: string;
  image: string;
};
@Component({
  selector: 'fgb-menu-carousel',
  templateUrl: './menu-carousel.component.html',
  styleUrls: ['./menu-carousel.component.scss'],
})
export class MenuCarouselComponent implements OnInit {
  constructor() {}
  isDragging: boolean = false;
  carouselListItems: CarouselItemsType[] = [
    {
      key: 0,
      redirectUrl: '/rewards/raffles',
      image: 'banner-images/rewards-banner-mobile.png',
    },
    {
      key: 1,
      redirectUrl: '/challenges',
      image: 'banner-images/challenges-banner-mobile.png',
    },
    {
      key: 2,
      redirectUrl: '/games',
      image: 'banner-images/games-banner-mobile.png',
    },
    {
      key: 3,
      redirectUrl: '/rewards/wallet',
      image: 'banner-images/wallet-banner-mobile.png',
    },
    {
      key: 4,
      redirectUrl: '/worksheet',
      image: 'banner-images/worksheets-banner-mobile.png',
    },
    {
      key: 5,
      redirectUrl: '/gallery',
      image: 'banner-images/gallery-banner.png',
    },
  ];
  customOptions: OwlOptions = {
    margin: 22,
    autoWidth: true,
    pullDrag: false,
    autoplay: false,
    navSpeed: 700,
    nav: false,
    dots: true,
    responsive: { 0: { items: 1 }, 900: { items: 3 } },
  };
  ngOnInit(): void {}
}
